<mibi-box-layout>

    <div class="mibi-last-change">
        <div class="mibi-last-change__content" [mibiToolTip]="versionToolTips">Letzte Änderung:
            {{lastChange$ | async | amDateFormat:'DD.MM.YYYY' }}</div>
    </div>

</mibi-box-layout>